export const RoutePaths = {
  HOME: '/',
  REGISTER: '/registrera',
  TRYOUT: '/prova',
  RESET_PASSWORD_REQUEST: '/glomt-losenord',
  NEW_PASSWORD: '/nytt-losenord',
  VERIFY: '/verifiera-epost',
};
